export type LessonKind = "video" | "article" | "quiz" | "project";

export type Lesson = {
  id: string;
  title: string;
  content: string;
  kind: LessonKind;
  transcript: string;
  captionsUrl: string | null;
  thumbnailUrl?: string | null;
  preview: boolean;
  durationMinutes: number;
  position: number;
  published: boolean;
  videoUrl: string | null;
  videoSource: "vimeo" | "external" | "mux" | null;
};

export type Module = {
  id: string;
  title: string;
  position: number;
  lessons: Lesson[];
};

/**
 * Runs an API call, refreshes the admin caches and reports whether it worked.
 * Owned by `AdminPanel`; passed down so every editor reports errors the same way.
 */
export type Mutate = (
  action: () => Promise<unknown>,
  message: string,
  courseId?: string,
) => Promise<boolean>;

/** Why a lesson is not ready to publish, or null when it is complete. */
export function lessonIssue(lesson: Lesson): string | null {
  if (!lesson.title.trim()) return "Sin título";
  if (lesson.kind === "video" && !lesson.videoUrl) return "Falta el video";
  if (lesson.kind === "article" && !lesson.content.trim())
    return "Sin contenido";
  return null;
}
